$(document).ready(function () {
  var sortWidth = $("#sort-by").width();
  var optionWidth = $("#sort-by option").filter(":selected").text();
  if (optionWidth == "Featured") {
    $("#sort-by").width("7em");
  } else if (
    optionWidth == "Price: Low to High" ||
    optionWidth == "Price: High to Low"
  ) {
    $("#sort-by").width("13em");
  } else if (optionWidth == "A-Z" || optionWidth == "Z-A") {
    $("#sort-by").width("2.5em");
  } else if (
    optionWidth == "Date, old to new" ||
    optionWidth == "Date, new to old"
  ) {
    $("#sort-by").width("12em");
  } else if (optionWidth == "Best Selling") {
    $("#sort-by").width("9em");
  } else if (optionWidth == "Newest") {
    $("#sort-by").width("6em");
  }
  console.log(optionWidth);
});

$(document).ready(function () {
  $("#sort-by").bind("change", function () {
    $("#width_tmp_option").html($("#sort-by option:selected").text());
    $(this).width($("#width_tmp_select").width());``
  });
});

// Nov 3, 2026: the selected option comes from snippets/sorting.liquid (Liquid does not run in
// this asset, so the old .val("{{ ... }}") call left the dropdown blank). Changing the sort keeps
// every active filter value (the old key/value object kept only one value per filter) and starts
// again from page 1.
jQuery("#sort-by").bind("change", function () {
  var params = new URLSearchParams(location.search);
  params.set("sort_by", jQuery(this).val());
  params.delete("page");
  location.search = params.toString();
});
